import React, { useContext, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import qs from 'query-string';
import PropTypes from 'prop-types';
import {
  Button,
  Col,
  Row
} from 'reactstrap';
import { AdvancedFilterItem, AdvancedSearch, SortEngine } from "./components";
import DataTableContext from '../../context/DataTableContext';

export const BASE_CONDITION_COMPONENT = { order: 0, component: AdvancedFilterItem };
export const BASE_CONDITION = { order: 0, searchValue: '', column: '', operation: '' };
const BASE_SORT_DATA = { sortDirection: 'asc', sortColumn: '' };

const initUrlConditions = (urlParams) => {
  const conditions = Object.keys(urlParams)
    .filter(k => k.indexOf('column_') > -1)
    .map((key, index) => {
      const cond = {};
      cond.order = index;
      cond.column = urlParams[key];
      cond.operation = urlParams[`operation_${index}`];
      cond.searchValue = urlParams[`searchValue_${index}`];

      return !cond.column
        || !cond.operation
        || !cond.searchValue ? null : cond;
    });

  return conditions.every(cond => !cond) ? [Object.assign({}, BASE_CONDITION)] : conditions.filter(cond => cond);
};

const initConditionComponents = (urlParams) => {
  const components = Object.keys(urlParams)
    .filter(k => k.indexOf('column_') > -1)
    .map((key, index) => {
      if (!urlParams[key] || !urlParams[`operation_${index}`] || !urlParams[`searchValue_${index}`]) return null;

      const newComponent = Object.assign({}, BASE_CONDITION_COMPONENT);
      newComponent.order = index;

      return newComponent;
    });

  return components.every(comp => !comp)
    ? [Object.assign({}, BASE_CONDITION_COMPONENT)]
    : components.filter(comp => comp);
};

const initSortData = (urlParams) => {
  if (!urlParams.sortDirection || !urlParams.sortColumn) return Object.assign({}, BASE_SORT_DATA);

  const sortData = Object.assign({}, BASE_SORT_DATA);
  sortData.sortDirection = urlParams.sortDirection;
  sortData.sortColumn = urlParams.sortColumn;

  return sortData;
};

const AdvancedFilter = (props) => {
  const dataTableContext = useContext(DataTableContext);
  const history = useHistory();
  const { columns } = props;
  const { search } = useLocation();
  const params = qs.parse(search);
  const [conditionComponents, setConditionComponents] = useState(initConditionComponents(params));
  const [sortData, setSortData] = useState(initSortData(params));
  const [conditions, setConditions] = useState(initUrlConditions(params));

  const applyFilters = () => {
    const searchConditions = conditions
      .filter(cond => cond.column && cond.operation && cond.searchValue).map(cond => {
        const newCond = {};
        newCond[`column_${cond.order}`] = cond.column;
        newCond[`operation_${cond.order}`] = cond.operation;
        newCond[`searchValue_${cond.order}`] = cond.searchValue;

        return newCond;
      });
    const validSortData = (sortData.sortColumn && sortData.sortDirection) ? sortData : {};
    const allParams = { ...Object.assign({}, ...searchConditions), ...validSortData };

    if (allParams && Object.entries(allParams).length > 0) {
      dataTableContext.updateDatasource(allParams);
    }
  };

  const cleanFilters = () => {
    const urlParams = qs.parse(search);
    const keysToDelete = [...Object.keys(urlParams).filter(k => {
      return k.indexOf('column_') > -1 ||
        k.indexOf('operation_') > -1 ||
        k.indexOf('searchValue_') > -1;
    }), 'sortColumn', 'sortDirection'];

    keysToDelete.forEach(key => urlParams[key] = undefined);
    dataTableContext.updateDatasource(urlParams);
    history.push(`?${qs.stringify(urlParams)}`);

    setSortData(BASE_SORT_DATA);
    setConditions([Object.assign({}, BASE_CONDITION)]);
    setConditionComponents([Object.assign({}, BASE_CONDITION_COMPONENT)]);
  };

  const onEnter = (e) => {
    if (e.key === 'Enter') applyFilters();
  };

  return (
    <Row>
      <Col xs="12">
        <div id="advanced-filter" data-testid="advanced-filter" onKeyDown={onEnter}>
          <Col xs="6" className="advanced-filter-component">
            <h5>Ordenação</h5>
            <SortEngine
              data={sortData}
              columns={columns}
              setSortData={setSortData} />
          </Col>
          <Col xs="12" className="advanced-filter-component">
            <h5>Busca Avançada</h5>
            <AdvancedSearch
              conditionComponents={conditionComponents}
              conditions={conditions}
              setConditionComponents={setConditionComponents}
              setConditions={setConditions}
              columns={columns} />

            <div className="filter-actions">
              <Button color="success" className="mr-1" onClick={applyFilters}>Aplicar</Button>
              <Button onClick={cleanFilters}>Limpar Filtros</Button>
            </div>
          </Col>
        </div>
      </Col>
    </Row>
  );
};

AdvancedFilter.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired
  })),
};

export default AdvancedFilter;